import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import sites from './routes/sites'
import campaigns from './routes/campaigns'
import networks from './routes/networks'
import dashboards from './routes/dashboards'
import devices from './routes/devices'
import objects from './routes/objects'
import settings from './routes/settings'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/regions',
      name: 'regions',
      component: () => import('@/views/Dashboards/Regions/Regions.vue'),
      meta: {
        pageTitle: 'Regions',
        breadcrumb: [
          {
            text: 'Regions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login/:email/:password/:signIn',
      name: 'auth-login',
      component: () => import('@/views/authentication/Login-v1.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/authentication/SignUp/SignUp.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/signedup/:email',
      name: 'signedup',
      component: () => import('@/views/authentication/SignedUp.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/confirmsignup/:email/:code/:submit',
      name: 'confirmsignup',
      component: () => import('@/views/authentication/ConfirmSignUp.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/authentication/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/temp-password/:email/:tempPass',
      name: 'temp-password',
      component: () => import('@/views/authentication/TempPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    ...sites,
    ...campaigns,
    ...dashboards,
    ...devices,
    ...networks,
    ...objects,
    ...settings,
    {
      path: '/account-setting',
      name: 'account-setting',
      component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
      meta: {
        pageTitle: 'Account Settings',
        breadcrumb: [
          {
            text: 'Pages',
          },
          {
            text: 'Account Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.attributes['custom:role'] : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
